import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb07ee0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "express-select" }
const _hoisted_2 = { class: "fx-1 name" }
const _hoisted_3 = {
  key: 1,
  class: "ver-select flex-ter"
}
const _hoisted_4 = { class: "fx-1" }
const _hoisted_5 = { class: "express-select-table" }
const _hoisted_6 = { width: "200" }
const _hoisted_7 = { width: "172" }
const _hoisted_8 = { class: "index-icon" }
const _hoisted_9 = { class: "icon-top" }
const _hoisted_10 = {
  src: "https://static-s.theckb.com/BusinessMarket/icon/Lifting_active.png",
  alt: "",
  class: "active",
  style: {"margin-left":"1px"}
}
const _hoisted_11 = {
  src: "https://static-s.theckb.com/BusinessMarket/icon/Lifting.png",
  alt: ""
}
const _hoisted_12 = { class: "icon-bottom" }
const _hoisted_13 = {
  src: "https://static-s.theckb.com/BusinessMarket/icon/Lifting_active.png",
  alt: "",
  class: "active"
}
const _hoisted_14 = {
  src: "https://static-s.theckb.com/BusinessMarket/icon/Lifting.png",
  alt: "",
  style: {"margin-left":"1px"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { width: "200" }
const _hoisted_17 = { class: "flex-ter express-name" }
const _hoisted_18 = { class: "name" }
const _hoisted_19 = { width: "172" }
const _hoisted_20 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`no-goods `)
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { style: {"color":"var(--blcolor)","opacity":"unset"} }
const _hoisted_24 = {
  key: 1,
  class: "price"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }

import { t, message as messageList } from '@/plugins/i18n'
import { computed, ref, onMounted, onUnmounted, watch } from 'vue'
import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
import { throughCountryGetExpressApi } from '@/apis/user'
import { getOrderExpressListApi } from '@/apis/inShipping'
import { isD2C, useSite2Station, useSite, getWarehouseCode } from '@/store'
import Image from '@/components/common/Image.vue'
import { formatMoneyDirection } from '@/util/useYan'
import { COUNTRY } from '@/global'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: ['id', 'placeholder', 'getData', 'defaultExpress', 'beforeSave', 'feeTip', 'className', 'countryCode', 'disabled'],
  emits: ['update:id', 'change'],
  setup(__props, { emit: emits }) {

const props = __props
const visible = ref(false)
const loading = ref(false)
const sortStatus = ref(0)
// getData 获取商品数据
// defaultExpress 默认物流列表


const expressList: any = ref([])
const originExpressList: any = ref([])
const activeExpress = computed(() => {
  if (!props.id) return {}
  return props.defaultExpress?.find((i) => i.intShipConfigId === props.id) ?? {}
})
const changeSort = () => {
  if (sortStatus.value === 2) {
    sortStatus.value = 0
    expressList.value = originExpressList.value
    return
  }
  sortStatus.value++
  expressList.value = expressList.value.filter((v) => v.price).sort((a, b) => !a.price ? 1 : sortStatus.value === 1 ? a.price - b.price : b.price - a.price).concat(expressList.value.filter((v) => !v.price))
}
const expressSelectPopperRef = ref()
const changeExpress = async (item: any) => {
  loading.value = true
  if (props.beforeSave && !await props.beforeSave(item)) {
    loading.value = false
    return
  }
  emits('update:id', item.intShipConfigId)
  visible.value = false
  emits('change', item.intShipConfigId, item)
  loading.value = false
}
const isChildOf = (child: any, parent: any) => {
  if (child && parent) {
    let parentNode = child.parentNode
    while (parentNode) {
      if (parent === parentNode) {
        return true
      }
      parentNode = parentNode.parentNode
    }
  }
  return false
}
const clickFn = (e: any) => {
  if (!visible.value) return
  const ele1 = document.querySelector(`.${props.className ?? 'express-select-popper'} .express-select-table`)
  const ele2 = document.querySelector(`.${props.className ?? 'ver-select-content'} .ver-select`)
  console.log(isChildOf(e.target, ele1))
  console.log(isChildOf(e.target, ele2), ele2)
  if (!isChildOf(e.target, ele1) && !isChildOf(e.target, ele2)) {
    console.log('隐藏')
    visible.value = false
  }
}
onMounted(() => {
  window.addEventListener('mouseup', clickFn)
})
onUnmounted(() => {
  window.removeEventListener('mouseup', clickFn)
})

const change = async () => {
  visible.value = !visible.value
  if (visible.value) {
    expressList.value = props.defaultExpress
    loading.value = true
    const data = await props.getData?.() ?? {}
    if (!data) {
      visible.value = false
      return
    }
    const codeMessage = messageList.apiCode[useSite()]
    const { data: list } = await getOrderExpressListApi({
      systemSource: isD2C() ? '1' : '2',
      stationCode: useSite2Station(),
      warehouseCode: getWarehouseCode(props.countryCode === COUNTRY.KR),
      ...data
    })

    const newList = list?.map((v, i) => {
      return {
        ...v,
        sort: v.price ?? -1,
        isHaveGoods: data.skuList?.length > 0,
        deliveryDays: JSON.parse(v.deliveryDays || '{}'),
        errorCodeMsg: v.code ? codeMessage[v.code]?.replace('X', v.errorMsg) : null
      }
    }) ?? []

    newList.sort((item1: any, item2: any) => item2.sort - item1.sort)

    expressList.value = newList
    originExpressList.value = JSON.parse(JSON.stringify(newList))
    loading.value = false
  }
}
const choiceTip = () => {
  ElMessage.warning(t('此物流线路只对代采商品生效，choice商品无法选定物流线路'))
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      placement: "bottom",
      width: __props.countryCode === _unref(COUNTRY).CN ? 550 : 300,
      trigger: "click",
      "popper-class": 'express-select-popper ' + __props.className,
      "show-arrow": false,
      ref: (_value, _refs) => {
        _refs['expressSelectPopperRef'] = _value
        expressSelectPopperRef.value = _value
      },
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event))
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (__props.disabled ? choiceTip() : change()), ["stop"])),
          class: _normalizeClass(__props.className ?? 'ver-select-content')
        }, [
          (_unref(activeExpress)?.intShipConfigId)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "ver-select flex-ter",
                style: _normalizeStyle({cursor: __props.disabled ? 'no-drop' :''})
              }, [
                _createVNode(Image, {
                  src: _unref(activeExpress).logo,
                  alt: "",
                  class: "img"
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(activeExpress).distribution), 1),
                (visible.value)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowUp))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowDown))
                      ]),
                      _: 1
                    }))
              ], 4))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(__props.placeholder ?? _unref(t)('请选择')), 1),
                (visible.value)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowUp))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowDown))
                      ]),
                      _: 1
                    }))
              ]))
        ], 2)
      ]),
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(t)('运输公司')), 1),
              (__props.countryCode === _unref(COUNTRY).CN)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("th", _hoisted_7, [
                      _createElementVNode("div", {
                        class: "flex-center cursor-pt",
                        onClick: changeSort
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('预估运输费用')), 1),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
                              [_vShow, sortStatus.value === 1]
                            ]),
                            _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
                              [_vShow, sortStatus.value !== 1]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [
                              [_vShow, sortStatus.value === 2]
                            ]),
                            _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
                              [_vShow, sortStatus.value !== 2]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("th", null, _toDisplayString(_unref(t)('运输时效')), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_el_scrollbar, {
            height: "220px",
            always: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("table", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expressList.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: _normalizeClass(["express-tr", { active: item.intShipConfigId === _unref(activeExpress)?.intShipConfigId }]),
                    onClick: ($event: any) => (changeExpress(item)),
                    key: item.intShipConfigId
                  }, [
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(Image, {
                          src: item.logo,
                          alt: "",
                          style: {"width":"28px","height":"28px"}
                        }, null, 8, ["src"]),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(item.distribution), 1)
                      ])
                    ]),
                    (__props.countryCode === _unref(COUNTRY).CN)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("td", _hoisted_19, [
                            (item.isHaveGoods)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                  (item.price !== null)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(`${item.priceCny}${_unref(t)('元')}
                      (${_unref(formatMoneyDirection)(item.price)})`), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                        _createTextVNode(_toDisplayString(_unref(t)('费用暂时无法预估')) + " ", 1),
                                        (item.code)
                                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                              key: 0,
                                              placement: "top",
                                              trigger: "hover",
                                              effect: "light",
                                              content: item.errorCodeMsg
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("a", _hoisted_23, _toDisplayString(_unref(t)('原因')) + ">", 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["content"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(__props.feeTip ?? '-'), 1))
                          ]),
                          _createElementVNode("td", null, [
                            (item.deliveryDays?.deliveryDayStart)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(t)('约')) + _toDisplayString(item.deliveryDays?.deliveryDayStart) + "-" + _toDisplayString(item.deliveryDays?.deliveryDayEnd) + _toDisplayString(_unref(t)('天')), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_26, "-"))
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_15))
                }), 128))
              ])
            ]),
            _: 1
          })
        ], 512), [
          [_directive_loading, loading.value]
        ])
      ]),
      _: 1
    }, 8, ["width", "popper-class", "visible"])
  ]))
}
}

})